import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LoggerService } from './logger.service';
import { Observable } from 'rxjs';

const PATH_FILE = 'app/shared/auth.guard.ts';

@Injectable()
export class AuthGuard  {
  constructor(
    private router: Router,
    public authService: AuthService,
    private _logger: LoggerService
    ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    this._logger.debug(PATH_FILE + ' - canActivate BEGIN');
    this._logger.debug(PATH_FILE + ' - canActivate route: ', route);
    this._logger.debug(PATH_FILE + ' - canActivate state: ', state);
    this.authService.logTokenInfos(PATH_FILE + ' - canActivate - akutelles Token');
    let isAuth = this.authService.isAuthenticated();

    // Wenn nicht Authentifiziert umleiten zur Login-Seite
    if(!isAuth)
      this.router.navigate(['/']);
    return isAuth;
  }
}
